(function () {
    'use strict';

    angular.module('Services').factory('ConsolidatedShipmentsTable', ConsolidatedShipmentsTable);
    ConsolidatedShipmentsTable.$inject = [
        '$filter',
        'TableLiteFactory',
        'Shipments',
        'Carrier',
        '$uibModal',
        '$q',
        'toastr'
    ];

    function ConsolidatedShipmentsTable(
        $filter,
        TableLiteFactory,
        Shipments,
        Carrier,
        $uibModal,
        $q,
        toastr
    ) {
        return function (defaultFilters = {}) {
            const presetFilters = angular.extend(angular.copy(defaultFilters), { shipmentConsolidation: true });
            
            const bookingStatuses = {
                inprogress: 'Processing',
                processed: 'Completed',
                pending: 'Awaiting Booking'
            };

            let consolidationTableData = {
                tableName: 'ConsolidatedShipments',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '135px'
                },
                headers: [{
                    label: 'Created Date',
                    viewName: 'createdDate',
                    filterName: 'createdDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[0]) : '',
                        fromModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[1]) : '',
                        useArray: true,
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CONSIGNMENT NO.',
                    viewName: 'consignmentId',
                    filterName: 'consignmentId',
                    filter: {
                        type: 'text',
                        class: 'filter-consignment-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'RECEIPT NO.',
                    viewName: 'receiptNo',
                    filterName: 'paymentDetails.receiptNumber',
                    width: '135px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'PICKUP REFERENCE NO.',
                    viewName: 'dhlBookingReferenceNo',
                    filterName: 'carrierOrderId',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CUSTOMER REF. NO.',
                    viewName: 'customerReferences',
                    filterName: 'customerReferences',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Third Party System Reference No.',
                    viewName: 'wmsReferenceNo',
                    filterName: 'wmsReferenceNo',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },  {
                    label: 'Payment Type',
                    viewName: 'paymentType',
                    filterName: 'paymentDetails.paymentType',
                }, {
                    label: 'BOOKING STATUS',
                    viewName: 'bookingStatus',
                    filterName: 'bookingStatus',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: [{
                            value: 'pending',
                            viewName: 'Awaiting Booking'
                        }, {
                            value: 'inprogress',
                            viewName: 'Processing'
                        }, {
                            value: 'processed',
                            viewName: 'Completed'
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        },
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        model: defaultFilters ? defaultFilters.carrierProfile : '',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.getExternalCarrierProfiles((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, { size: 30, name: model });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'SERVICE PROFILE',
                    viewName: 'serviceProfileName',
                    filterName: 'serviceProfileId',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'displayName',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) { 
                            const defer = $q.defer();
                            let filterItems = this.items;
                           
                            Carrier.getServiceProfiles((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {
                                    size: 30,
                                    name: model,
                                    carrierProfileId: tableActions.activeFilters.carrierProfileId
                                });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'No. Packages',
                    viewName: 'noPackages'
                }, {
                    label: 'SENDER CODE',
                    viewName: 'senderCode',
                }, {
                    label: 'RECEIVER CODE',
                    viewName: 'receiverCode'
                }, {
                    label: 'DESTINATION',
                    viewName: 'destination'
                }, {
                    label: 'STATUS',
                    viewName: 'status'
                }, {
                    label: 'Actions',
                    viewName: 'actions',
                    class: 'text-center'
                }],
                data: [],
                resetFilters: function(){
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                }
            }

            const tableActions = new TableLiteFactory(consolidationTableData,
                {
                    serviceCallback: Shipments.getConsolidatedShipments,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'createdDate,desc'
                    }, presetFilters)
                }
            );

            function buildTableData(data) {
                if (!data) { return consolidationTableData };

                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.createdDate = $filter('bbaDate')(item.createdDate); // Format Date MM/dd/YYYY
                    item.consignmentId = item.consignmentId || 'N/A';
                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';

                    if (angular.getObjVal(item, 'customerReferences')) {
                        item.customerReferences = item.customerReferences.length ? item.customerReferences.join(', '): 'N/A'; 
                    } else {
                        item.customerReferences = 'N/A';
                    }
                    
                    item.wmsReferenceNo = item.wmsReferenceNo || 'N/A';
                    item.dhlBookingReferenceNo = angular.getObjVal(item, 'carrierOrderId') || 'N/A';

                    item.bookingStatus = bookingStatuses[item.bookingStatus];
                    item.noPackages = angular.getObjVal(item, 'consolidation.totalPackages') || 0;
                    item.senderCode = angular.getObjVal(item, 'consolidation.senderCode') || 'N/A';
                    item.receiverCode = angular.getObjVal(item, 'consolidation.receiverCode') || 'N/A';
                    item.paymentType = angular.getObjVal(item, 'paymentDetails.paymentType') ? 'Credit Card' : 'On Account';

                    item.destination = `${item.destinationAddress.addressLine1} ${item.destinationAddress.addressLine2},
                                          ${item.destinationAddress.location.name}, ${item.destinationAddress.location.code}, ${item.destinationAddress.location.country.name}`

                    item.status = angular.getObjVal(item, 'consolidation.closed') ? 'Closed' : 'Open';
                    item.actions = actionButtons(item);
                    item.receiptNo = angular.getObjVal(item, 'paymentDetails.receiptNumber') || 'N/A';
                    item.href = '/shipments/view/' + item.id;
                    consolidationTableData.data.push(item);
                });
            }

            function actionButtons(shipment) {
                return {
                    type: 'button',
                    buttons: [{
                        text: 'ORDERS',
                        icon: '',
                        class: 'btn-primary',
                        action: (data) => {
                            showOrdersModal(shipment);
                        }
                    }]
                }
            }

            function showOrdersModal(shipment) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/shipments/consolidated-shipment-orders-modal.html',
                    controller: 'ConsolidatedShipmentOrdersModal',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        shipmentData: function(){
                            return shipment;
                        }
                    }
                });
            }

            this.tableData = consolidationTableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/ConsolidatedShipmentsTable.js